import React from "react";
import { ReactComponent as LightLogoIllustration } from "../../logoLight.svg";
import { ReactComponent as DarkLogoIllustration } from "../../logoDark.svg";
import { ReactComponent as DefaultLogoIllustration } from "../../logo.svg";

const Logo = ({ size, mode }) => {
  const fontSize = size || 36;
  const normalizedMode = String(mode || "default").toLowerCase();

  if (normalizedMode === "light") {
    return <LightLogoIllustration width={fontSize} height={fontSize} />;
  }

  if (normalizedMode === "dark") {
    return <DarkLogoIllustration width={fontSize} height={fontSize} />;
  }

  return <DefaultLogoIllustration width={fontSize} height={fontSize} />;
};

export default Logo;
